import UnlockIcon from '@assets/icons/UnlockIcon'
import Chip from '@mui/material/Chip'
import { T } from '@transifex/react'

type AwardTypePointsChipProps = {
  points: number
  pointsLocked: boolean
  isNomination: boolean
}

const AwardTypePointsChip: React.FC<AwardTypePointsChipProps> = ({
  points,
  pointsLocked,
  isNomination,
}) => {
  if (!points || points === 0) return null

  return (
    <Chip
      variant="info"
      sx={{
        width: 'fit-content',
        pr: 1.5,
      }}
      label={
        <T
          _str="{count} {count, plural, one {point} other {points}}"
          count={points.toLocaleString()}
        />
      }
      onDelete={pointsLocked || isNomination ? undefined : () => undefined}
      deleteIcon={pointsLocked || isNomination ? undefined : <UnlockIcon fontSize="18px" />}
    />
  )
}

export default AwardTypePointsChip
